<template>
  <section
    :id="'cat-' + categoryId"
    class="cat-section reveal visible"
  >
    <div class="cat-section-header">
      <h2 class="cat-section-title">
        {{ categoryName }}
      </h2>
      <router-link
        to="/goods"
        class="cat-section-view"
        v-if="total > 8"
      >
        View All →
      </router-link>
    </div>
    <div class="product-grid-center">
      <div
        v-for="row in list"
        :key="row.id"
        class="product-card"
      >
        <div class="product-img-wrap">
          <img
            class="product-img"
            :src="row.goodsImage"
            :alt="row.goodsName"
            loading="lazy"
            @error="onImgErr"
          >
        </div>
        <div class="product-info">
          <div class="product-name">
            {{ row.goodsName }}
          </div>
          <div class="product-pricing">
            <span class="product-price">
              {{ row.price }} {{ row.currencySymbol || '$' }}
            </span>
          </div>
          <span
            class="product-buy"
            @click.stop="onConveyorBuyClick(row)"
          >
            Buy on {{ selectPlatform.platformName }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import productApi from '@/api/product'

export default {
  name: 'ClassifyShirts',

  props: {
    categoryName: {
      type: String,
      default: '',
    },
    categoryId: {
      type: String,
      default: '',
    },
    selectPlatform: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      list: [],
      total: 0
    }
  },

  watch: {
    categoryName: {
      handler(newVal) {
        this.getGoodsList();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    /** 获取商品列表 */
    async getGoodsList() {
      const params = {
        pageNum: 1,
        pageSize: 8,
        categoryName: this.categoryName,
      }

      try {
        const { rows, total } = await productApi.getGoodsList(params)
        this.list = rows || [];
        this.total = total || 0;
      } catch (error) {
        console.error(error)
      }
    },

    /** 购买按钮 */
    onConveyorBuyClick(goods) {
      if (!this.selectPlatform.platformId) {
				return this.$message.warning(this.$t('selectPlatform'));
			}
			var url = this.selectPlatform.platformUrl;
			if (url.indexOf('{goodId}') != -1) {
				url = url.replace('{goodId}', goods.weidianGoodsId);
			}
			if (url.indexOf('{weidian}') != -1) {
				url = url.replace('{weidian}', goods.weidianId);
			}
			if (url.indexOf('{inviteCode}') != -1) {
				url = url.replace('{inviteCode}', this.selectPlatform.invitationCode);
			}
			window.open(url);
    },

    /** 商品图失败时用表面色块兜底 */
    onImgErr(e) {
      const el = e.target
      if (el && el.style) el.style.background = 'var(--surface)'
    },
  },
}
</script>

<style scoped>
@import '../styles/mr-put-you-on-finds-fonts.css';
@import '../styles/type2-style.scss';
</style>
